module.exports = __webpack_public_path__ + "img/marker-point-verde-claro.1c7d14fc.png";